import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef, Fragment } from 'react';
import { ChevronRightSolidIcon } from '@compono/ui-icons';
import { getHash } from '../utils/simpleInsecureHash.js';
import { renderProp } from '../utils/renderProp.js';
import { Box } from '../Box/index.js';
import { IconBox } from '../IconBox/index.js';
import { useTreeCardContext } from './TreeProvider.js';

var buttonSizeMap = {
    sm: "xs",
    md: "sm",
    lg: "md",
};
var textSizeMap = buttonSizeMap;
var TreeCardContent = forwardRef(function TreeCardContent(props, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) {
    var isExpandable = props.isExpandable, node = props.node;
    var _a = useTreeCardContext(), activeNode = _a.activeNode, nodeAction = _a.nodeAction, isTreeActive = _a.isTreeActive, events = _a.events, hideDescription = _a.hideDescription, getActionButtonProps = _a.getActionButtonProps, size = _a.size;
    var isNodeActive = (activeNode === null || activeNode === void 0 ? void 0 : activeNode.id) === node.id;
    var getTabIndex = function () {
        if (isNodeActive)
            return 0;
        return -1;
    };
    var actionButtonProps = getActionButtonProps(getTabIndex());
    node.children; var nodeWithoutChildren = __rest(node, ["children"]);
    return (jsxs(Box, __assign({ ref: ref, "data-value": node.id, "data-is-active": isTreeActive && isNodeActive, "data-has-children": isExpandable, "data-testid": "tree-content", themeKey: "treeCardContent", sx: {
            gridTemplateAreas: isExpandable
                ? '"icon content action" ". content ."'
                : '". content action" ". content ."',
            gridTemplateColumns: isExpandable
                ? "min-content auto min-content"
                : "var(--icon-box-size) auto min-content",
            alignItems: "center",
            color: "black.100",
        } }, events, { children: [isExpandable && (jsx(IconBox, { "data-is-open": node.expanded, size: "xs", sx: {
                    gridArea: "icon",
                    height: "var(--icon-box-size)",
                    width: "var(--icon-box-size)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: buttonSizeMap[size],
                    '&[data-is-open="true"] [data-ui-icon]': {
                        transform: "rotate(90deg)",
                    },
                    alignSelf: "flex-start",
                }, position: "left", icon: ChevronRightSolidIcon })), jsxs(Box, __assign({ sx: {
                    p: "var(--card-padding)",
                    gridArea: "content",
                } }, { children: [jsx(Box, __assign({ sx: { font: size } }, { children: node.label })), !hideDescription && node.description && (jsx(Box, __assign({ sx: {
                            font: textSizeMap[size],
                            color: "black.60",
                        } }, { children: node.description.split(/\n/).map(function (text, idx) { return (jsxs(Fragment, { children: [text, jsx("br", {})] }, getHash("".concat(text, "-").concat(idx)))); }) })))] })), nodeAction && (jsx(Box, __assign({ sx: { gridArea: "action", alignSelf: "flex-start", display: "flex" } }, { children: renderProp({
                    prop: nodeAction,
                    context: {
                        node: nodeWithoutChildren,
                        actionButtonProps: actionButtonProps,
                    },
                }) })))] })));
});
TreeCardContent.displayName = "TreeCardContent";

export { TreeCardContent, buttonSizeMap };
//# sourceMappingURL=TreeCardContent.js.map
